import {utilHelper} from '../../_helpers';

const relativeUrl = 'api/moduleMenu'

export const moduleMenuService = {
    getItem,
    saveItem,
    deleteItem,
    getAll : search,
    search,
    reorderItems
};


function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET');
}

function search(ofs, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', {data: data, showAlert:false})
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}


function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE');
}

//reorder
function reorderItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data: data });
}